interface ShouldShowOoTermFieldParams {
  canAccessHppPages: boolean;
  isCreateMode: boolean;
}

/**
 * Term visibility is a firm entitlement, not a case-status concern, so it never
 * depends on whether the case exists yet. `isCreateMode` is accepted only to keep
 * that explicit at the call site — non-HPP brokers must not see term on create either.
 */
export function shouldShowOoTermField({ canAccessHppPages }: ShouldShowOoTermFieldParams): boolean {
  return canAccessHppPages;
}
